module.exports = __webpack_public_path__ + "static/media/zero_touch_logo.314addbd.svg";